import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {
  AcceptRejectConfirmationModalComponent
} from 'src/app/admin/company/accept-reject-confirmation-modal/accept-reject-confirmation-modal.component';
import {StorageKeys} from 'src/app/share/enums/storage.enum';
import {UserSettingService} from 'src/app/share/services/User-Setting/user-setting.service';
import {StorageService} from 'src/app/share/services/storage-service/storage.service';
import {environment} from '../../../../environments/environment';
import {APPTYPES} from 'src/app/share/constants/common-constants';
import {CommonService} from 'src/app/share/services/common/common.service';
import {DocumentValutService} from 'src/app/share/document-valut/document-valut.service';
import {ViewDocumentComponent} from 'src/app/document-valut/view-document/view-document.component';
import { LookupService } from 'src/app/share/services/lookup/lookup.service';
import { ConfirmationPopupComponent } from 'src/app/share/popups/confirmation-popup/confirmation-popup.component';

@Component({
    selector: 'app-user-details',
    templateUrl: './user-details.component.html',
    styleUrls: ['./user-details.component.scss'],
    standalone: false
})

export class UserDetailsComponent implements OnInit {
  @Input() companyId        : any;
  @Input() parentData       : any;
  @Input() permissionData   : any;
  @Output() closePanel      : EventEmitter<void> = new EventEmitter<void>();
  @Output() editUser        : EventEmitter<any> = new EventEmitter<any>();
  @Output() userDeleted     : EventEmitter<any> = new EventEmitter<any>();
  @Output() disableMfa      : EventEmitter<any> = new EventEmitter<any>();
  @Output() departmentUpdated: EventEmitter<void> = new EventEmitter<void>();
  @Output() materialGroupUpdated: EventEmitter<void> = new EventEmitter<void>();
  userId                    : string;
  selfDetails               : any;
  isAdmin                   : boolean = false;
  isEsignApplicable         : boolean = true;
  isBlockChainApplicable    : boolean = true;
  isMFA                     : boolean = false;
  envType = environment?.envType || 'SDEX';
  appType = APPTYPES;
  isToaster                 : boolean = false;
  message                   : string;
  departmentDisplay         : string = '';
  departmentPage            : number = 0;
  departmentList            : any[] = [];
  isDepartmentLoading       : boolean = false;
  hasMoreDepartment         : boolean = true;
  previousSeletedDepartment : any;
  lastSearchQuery           : string;
  selectedDepartment        : any;
  isEditingDepartment       : boolean = false;
  editedDepartment          : any = null;
  companyid                 : any;
  isSuccessToster           : boolean = false;
  successMessage            : any;
  errorMessage              : any;
  loadAction                : boolean = false;
  companyPrefs              : any;
  materialGroupDisplay      : string = '';
  materialGroupPage         : number = 0;
  materialGroupList         : any[] = [];
  isMaterialGroupLoading    : boolean = false;
  hasMoreMaterialGroup      : boolean = true;
  previousSeletedMaterialGroups : any[] = [];
  lastMaterialGroupQuery    : string;
  selectedMaterialGroups    : any[] = [];
  isEditingMaterialGroup    : boolean = false;
  materialGroupErrorMessage : string;
  loadMaterialGroupAction   : boolean = false;


  constructor(
    private readonly modal: NgbModal,
    private readonly storageService: StorageService,
    private readonly userSettingService:UserSettingService,
    public commonService         : CommonService,
    private readonly documentService: DocumentValutService,
    private readonly lookupService: LookupService,
  ) { }

  onCloseIconClick() {
    this.closePanel.emit();
    document.body.classList.remove('panel-open');
  }

  ngOnInit(): void {
    if(this.parentData!== undefined){
    this.parentData = structuredClone(this.parentData);
    }
    this.selfDetails = this.storageService.getDataFromLocalStorage(StorageKeys.SELF_DETAILS);
    if (this.selfDetails) {
      this.userId = this.selfDetails._id;
      this.companyid = this.selfDetails?.company;
    }
    if (this.selfDetails?.enrollmentType === "Admin") {
      this.isAdmin = true;
    }
    if (Array.isArray(this.parentData?.departments) && this.parentData.departments.length > 0) {
      this.departmentDisplay = this.parentData.departments.map((d: any) => d?.name).filter(Boolean).join(', ');
    }
    this.getCompanyPrefs();
    this.getBlockChainKey();
    this.previousSeletedDepartment = this.parentData?.departments?.[0]?.name;
    this.setMaterialGroupSelection();
  }

  getCompanyPrefs() {
    this.userSettingService.getCompanyPrefs()?.subscribe({
      next: (response: any) => {
        this.companyPrefs = response?.data || {};
      },
      error: () => {
        this.companyPrefs = {};
      }
    });
  }

  deleteUser(id: string) {
    let dialogRef = this.modal.open(AcceptRejectConfirmationModalComponent, {
      backdrop: 'static',
      size: 'md',
      keyboard: false,
      centered: false,
    });
    dialogRef.componentInstance.userId = this.parentData?._id;
    dialogRef.componentInstance.buttonLabel = this.parentData?.status == 'Active' ? 'Lock' : 'Unlock';
    dialogRef.componentInstance.message = `Are you sure you want to ${this.parentData?.status == 'Active' ? 'lock' : 'unlock'} the user '${this.parentData.name ? this.parentData.name : ""}' ?`;
    dialogRef.result.then(
      (result) => {
        if (result?.status) {
          const action = this.parentData?.status === 'Active' ? 'locked' : 'unlocked';
          let message = `User '${this.parentData.name}' has been ${action} successfully!`;
          this.isToaster = true;
          this.closePanel.emit();
          this.userDeleted.emit({isToaster:true,message:message});
          document.body.classList.remove('panel-open');

        }

      },
      (reason) => {

      }
    );
  }


  closeToaster(){
    this.isToaster =false;
  }
  handleEditUser() {
    this.editUser.emit(this.parentData);
  }

  getBlockChainKey() {
    this.userSettingService.getblockchainkey(this.parentData?._id)?.subscribe(response => {
      this.parentData.isKeyGenerated = response.data.keyGenerated;
    });
  }

  disabledMFA() {
    this.disableMfa.emit();
  }

  closeMFAPanel(){
    this.isMFA = false;
  }
  onChange(e: any) {
    console.log(e);
  }

  getFile(id: string) {
    this.documentService.getFileById(id).subscribe((res: any) => {
      this.viewFile(res?.data);
    })
  }

  viewFile(file: any) {
    this.parentData.downloadLoader = true;
    this.documentService.exportEsignDocument({ _id: file._id, download: true }, true)?.subscribe({
      next: (response: any) => {
        file.isViewLoader = false;
        let viewDetails = { file: file, data: response };
        let files = new Blob([viewDetails?.data?.body], {
          type: viewDetails?.file?.mimeType
        });
        let pdfSrc = URL.createObjectURL(files);
        const modelRef = this.modal.open(ViewDocumentComponent, {
          ariaLabelledBy: 'modal-basic-title',
          size: 'lg',
        });
        this.parentData.downloadLoader = false;
        if (modelRef?.componentInstance) {
          modelRef.componentInstance.viewDetails = viewDetails;
          modelRef.componentInstance.pdfSrc = pdfSrc;
          modelRef.componentInstance.isSearch = true;
          modelRef.componentInstance.viewEsign = true;
          modelRef.result.finally(() => {
            this.parentData.downloadLoader = false;
          });
        }
      },
      error: (err: any) => {
        this.parentData.downloadLoader = false;
      }
    })
  }

  getDepartmentsList(query: string = '') {
    if (this.isDepartmentLoading) return;
    if (query !== this.lastSearchQuery) {
      this.departmentPage = 0;
      this.departmentList = [];
      this.hasMoreDepartment = true;
      this.lastSearchQuery = query;
    }
    if (!this.hasMoreDepartment) return;
    this.isDepartmentLoading = true;
    this.lookupService.getDepartmentList(this.companyid, {
      page: this.departmentPage,
      name: this.lastSearchQuery || '',
      userId: this.parentData?._id
    }).subscribe({
      next: (res: any) => {
        if (res?.data?.length) {
          this.departmentList = [
            ...res.data.map((x: any) => ({
              _id: x._id,
              name: x.name
            }))
          ];
          this.departmentPage++;
        } else {
          this.hasMoreDepartment = false;
        }
        this.isDepartmentLoading = false;
      }
    });
  }

  onSelectedDepartment(value: any) {
    this.selectedDepartment = value._id;
  }

  editDepartment() {
    this.isEditingDepartment = true;
    this.editedDepartment = this.parentData?.departments?.[0] || null;
    this.selectedDepartment = this.editedDepartment?._id || null;
    this.getDepartmentsList();
  }

  saveDepartment(update: boolean) {
    let payload: any = {
      userId: this.parentData?._id,
    };
    if (update) {
      payload.departmentIds = [this.selectedDepartment]
    } else {
      payload.departmentIds = []
    }
    this.loadAction = true;
    this.lookupService.assignDepartment(payload, this.companyid).subscribe({
      next: (res: any) => {
        if (update) {
          const selected = this.departmentList.find(dep => dep._id === this.selectedDepartment);
          if (selected) {
            this.parentData.departments = [selected];
            this.departmentDisplay = selected.name;
          }
        } else {
          this.parentData.departments = [];
          this.departmentDisplay = '';
          this.previousSeletedDepartment = ''
        }
        this.isEditingDepartment = false;
        this.loadAction = false;
        this.isSuccessToster = true;
        this.successMessage = res?.data?.message;
        this.departmentUpdated.emit();
      },
      error: (error: any) => {
        this.loadAction = false;
        this.errorMessage = error?.error?.error?.message;
      }
    });
  }

  cancelEditDepartment() {
    this.isEditingDepartment = false;
    const selected = this.parentData?.departments?.[0];
    this.selectedDepartment = selected?._id;
    this.departmentDisplay = selected?.name || '';
  }

  closeToster(value: boolean) {
    this.isSuccessToster = value;
  }

  unAssignDepartment() {
    let dialogRef = this.modal.open(ConfirmationPopupComponent, { keyboard: false, backdrop: "static" });

    if (dialogRef?.componentInstance) {
      dialogRef.componentInstance.header = 'Confirm unassign department to user';
      dialogRef.componentInstance.message = `Are you sure you want to unassign department`;
      dialogRef.componentInstance.lableName = 'Unassign';
      dialogRef.result.then(
        (result) => {
          if (result) {
            this.saveDepartment(false)
          }
        },
      );
    }
  }

  setMaterialGroupSelection() {
    const groups = Array.isArray(this.parentData?.materialGroups) ? this.parentData.materialGroups : [];
    this.materialGroupDisplay = groups.map((group: any) => group?.name).filter(Boolean).join(', ');
    this.previousSeletedMaterialGroups = groups.map((group: any) => group?._id).filter(Boolean);
    this.selectedMaterialGroups = [...this.previousSeletedMaterialGroups];
  }

  getMaterialGroupsList(query: string = '') {
    if (this.isMaterialGroupLoading) return;
    if (query !== this.lastMaterialGroupQuery) {
      this.materialGroupPage = 0;
      this.materialGroupList = [];
      this.hasMoreMaterialGroup = true;
      this.lastMaterialGroupQuery = query;
    }
    if (!this.hasMoreMaterialGroup) return;
    this.isMaterialGroupLoading = true;
    this.lookupService.getMaterialGroups(this.companyid, {
      page: this.materialGroupPage,
      name: this.lastMaterialGroupQuery || ''
    }).subscribe({
      next: (res: any) => {
        this.appendMaterialGroups(res?.data);
        this.isMaterialGroupLoading = false;
      },
      error: () => {
        this.isMaterialGroupLoading = false;
      }
    });
  }

  appendMaterialGroups(data: any[]) {
    if (!data?.length) {
      this.hasMoreMaterialGroup = false;
      return;
    }
    const loadedIds = this.materialGroupList.map((group: any) => group._id);
    const newGroups = data
      .filter((group: any) => !loadedIds.includes(group._id))
      .map((group: any) => ({ _id: group._id, name: group.name, materialCode: group.materialCode }));
    this.materialGroupList = [...this.materialGroupList, ...newGroups];
    this.materialGroupPage++;
  }

  onSelectedMaterialGroups(value: any) {
    this.selectedMaterialGroups = Array.isArray(value) ? [...value] : [];
  }

  editMaterialGroup() {
    this.isEditingMaterialGroup = true;
    this.materialGroupErrorMessage = '';
    this.selectedMaterialGroups = [...this.previousSeletedMaterialGroups];
    this.getMaterialGroupsList();
  }

  saveMaterialGroup(update: boolean) {
    const materialGroupIds = update ? [...this.selectedMaterialGroups] : [];
    const payload: any = {
      userId: this.parentData?._id,
      materialGroupIds: materialGroupIds
    };
    this.loadMaterialGroupAction = true;
    this.materialGroupErrorMessage = '';
    this.lookupService.assignMaterialGroup(payload, this.companyid).subscribe({
      next: () => {
        this.parentData.materialGroups = this.resolveMaterialGroups(materialGroupIds);
        this.setMaterialGroupSelection();
        this.isEditingMaterialGroup = false;
        this.loadMaterialGroupAction = false;
        this.isSuccessToster = true;
        this.successMessage = update ? 'Material group assigned successfully' : 'Material group unassigned successfully';
        this.materialGroupUpdated.emit();
      },
      error: (error: any) => {
        this.loadMaterialGroupAction = false;
        this.materialGroupErrorMessage = error?.error?.error?.message || error?.error?.message;
      }
    });
  }

  resolveMaterialGroups(materialGroupIds: any[]) {
    const knownGroups = [...(this.parentData?.materialGroups || []), ...this.materialGroupList];
    return materialGroupIds
      .map((id: any) => knownGroups.find((group: any) => group?._id === id))
      .filter(Boolean);
  }

  cancelEditMaterialGroup() {
    this.isEditingMaterialGroup = false;
    this.materialGroupErrorMessage = '';
    this.setMaterialGroupSelection();
  }

  removeMaterialGroup(group: any) {
    let dialogRef = this.modal.open(ConfirmationPopupComponent, { keyboard: false, backdrop: "static" });
    if (dialogRef?.componentInstance) {
      dialogRef.componentInstance.header = 'Confirm remove material group';
      dialogRef.componentInstance.message = `Are you sure you want to remove "${group?.name}"`;
      dialogRef.componentInstance.lableName = 'Remove';
      dialogRef.result.then(
        (result) => {
          if (result) {
            const remaining = this.previousSeletedMaterialGroups.filter((id: any) => id !== group?._id);
            this.selectedMaterialGroups = remaining;
            this.saveMaterialGroup(remaining.length > 0);
          }
        },
      );
    }
  }

  unAssignMaterialGroup() {
    let dialogRef = this.modal.open(ConfirmationPopupComponent, { keyboard: false, backdrop: "static" });
    if (dialogRef?.componentInstance) {
      dialogRef.componentInstance.header = 'Confirm unassign material group to user';
      dialogRef.componentInstance.message = `Are you sure you want to unassign material group`;
      dialogRef.componentInstance.lableName = 'Unassign';
      dialogRef.result.then(
        (result) => {
          if (result) {
            this.saveMaterialGroup(false)
          }
        },
      );
    }
  }

}
